export * from './Msal2Provider';
export * from './mgt-msal2-provider';
//# sourceMappingURL=index.js.map